import React from 'react';
import { Header, Icon, Segment, SemanticICONS } from 'semantic-ui-react';

export interface AzionePrincipaleProps {
    titolo: string,
    descrizione: string,
    icon: SemanticICONS,
    isMobile: boolean,
}

export default class AzionePrincipale extends React.Component<AzionePrincipaleProps> {
    render() {
        const dimensione = this.props.isMobile ? 'h4' : 'h3';
        return (
            <Segment>
                <Header as={dimensione}>
                    <Icon name={this.props.icon} />
                    <Header.Content>
                        {this.props.titolo}
                        <Header.Subheader>{this.props.descrizione}</Header.Subheader>
                    </Header.Content>
                </Header>
            </Segment>
        );
    }
}